import React, { useState } from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import ChargesPage from "@main/charges/pages/ChargesPage";
import CashReconciliationsPage from "@main/cash-reconciliations/pages/CashReconciliationsPage";
import DebtsPage from "@main/debts/pages/DebtsPage";
import { Calculator, CreditCard, Coin, Money } from "@phosphor-icons/react";
import { t } from "i18next";

function AccountingPage() {
  const [activeTab, setActiveTab] = useState("cash-reconciliations");

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <h2 className="card-header-title">
          <Calculator size={24} />
          <span className="ms-2">Contabilidad</span>
        </h2>
      </Card.Header>

      <Card.Body>
        <Tabs
          activeKey={activeTab}
          onSelect={(tab) => setActiveTab(tab || "cash-control")}
          className="mb-3"
        >
          <Tab
            eventKey="cash-reconciliations"
            title={
              <>
                <Coin size={18} />
                <span className="ms-1">Cierre de caja</span>
              </>
            }
          >
            <CashReconciliationsPage />
          </Tab>

          <Tab
            eventKey="cash-control"
            title={
              <>
                <CreditCard size={18} />
                <span className="ms-1">Control de caja</span>
              </>
            }
          >
            {/* Página de cobros existente */}
            <ChargesPage />
          </Tab>

          <Tab
            eventKey="debts"
            title={
              <>
                <Money size={18} />
                <span className="ms-1">{t("debts")}</span>
              </>
            }
          >
            <DebtsPage />
          </Tab>

          <Tab
            eventKey="annual-billing"
            title={
              <>
                <Calculator size={18} />
                <span className="ms-1">Facturación anual</span>
              </>
            }
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "300px" }}
            >
              <div className="text-center">
                <div className="mb-3">
                  <Calculator size={64} className="text-muted" />
                </div>
                <h4 className="text-muted">Facturación Anual</h4>
                <p className="text-muted mb-4">
                  Esta funcionalidad está en desarrollo
                </p>
                <button className="btn btn-outline-secondary" disabled>
                  En construcción
                </button>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
}

export default AccountingPage;
